import { render } from "./ReqAgentCertTHView.vue?vue&type=template&id=3b89d6a6"
import script from "./ReqAgentCertTHView.vue?vue&type=script&lang=js"
export * from "./ReqAgentCertTHView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__